<template>
 <div></div>
</template>

<script>
  import helper from "../helper";

  export default {
    name: 'Dashboard',
    data() {
      return {

      }
    },
    created() {

    },
    computed: {


    },
  }
</script>
